module.exports = __webpack_public_path__ + "static/media/29FUNOV15.7b60b5aa.jpg";